// Telika Theme - Modular Wishlist Functionality

document.addEventListener('DOMContentLoaded', function () {
  // Initialize Double Click main image to Wishlist
  initProductImageDblClickWishlist();

  // Initialize Wishlist Feature
  initWishlist();
});

// 1. Double Click Product Image to Wishlist
function initProductImageDblClickWishlist() {
  const slides = document.querySelectorAll('.main-image-slide');
  const wishlistBtn = document.querySelector('.wishlist-toggle-btn-product');

  if (!slides.length || !wishlistBtn) return;

  slides.forEach(slide => {
    slide.addEventListener('dblclick', function(e) {
      const handle = wishlistBtn.getAttribute('data-wishlist-handle');
      if (!handle) return;

      let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
      let added = false;
      if (wishlist.includes(handle)) {
        wishlist = wishlist.filter(h => h !== handle);
      } else {
        wishlist.push(handle);
        added = true;
      }
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      
      // Update header bubble counts
      if (window.updateWishlistCount) window.updateWishlistCount();
      
      // Sync buttons
      const buttons = document.querySelectorAll(`[data-wishlist-handle="${handle}"]`);
      buttons.forEach(btn => {
        if (added) {
          btn.classList.add('active');
          btn.style.color = '#ef4444';
        } else {
          btn.classList.remove('active');
          btn.style.color = '';
        }
      });

      // Instagram-style heart pop animation
      const rect = slide.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const heart = document.createElement('div');
      heart.className = 'floating-heart-pop';
      heart.innerHTML = `<svg viewBox="0 0 24 24" width="60" height="60" fill="#ef4444" stroke="#ef4444" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>`;
      heart.style.position = 'absolute';
      heart.style.left = `${x - 30}px`;
      heart.style.top = `${y - 30}px`;
      heart.style.pointerEvents = 'none';
      heart.style.zIndex = '100';
      heart.style.transform = 'scale(0) rotate(-15deg)';
      heart.style.opacity = '0';
      heart.style.transition = 'all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
      
      slide.appendChild(heart);

      setTimeout(() => {
        heart.style.transform = 'scale(1.2) rotate(0deg)';
        heart.style.opacity = '1';
      }, 10);

      setTimeout(() => {
        heart.style.transform = 'scale(0.8) translateY(-40px) rotate(15deg)';
        heart.style.opacity = '0';
      }, 500);

      setTimeout(() => {
        heart.remove();
      }, 1000);
    });
  });
}

// 2. Wishlist Feature (Client-side localStorage)
function initWishlist() {
  // Update wishlist bubble count in header
  function updateWishlistCount() {
    const countElement = document.querySelector('#header-wishlist-count');
    if (!countElement) return;

    const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    countElement.textContent = wishlist.length;

    if (wishlist.length > 0) {
      countElement.classList.remove('visually-hidden');
    } else {
      countElement.classList.add('visually-hidden');
    }
  }

  // Make it global so other scripts/sections can trigger update
  window.updateWishlistCount = updateWishlistCount;
  
  // Set initial count
  updateWishlistCount();

  // Check state of buttons and apply active class
  function syncWishlistButtons() {
    const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const buttons = document.querySelectorAll('[data-wishlist-handle]');

    buttons.forEach(btn => {
      const handle = btn.getAttribute('data-wishlist-handle');
      if (wishlist.includes(handle)) {
        btn.classList.add('active');
        btn.setAttribute('aria-label', 'Largo nga lista e dëshirave');
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-label', 'Shto në listën e dëshirave');
      }
    });
  }

  syncWishlistButtons();

  // Handle click events on wishlist toggle buttons
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-wishlist-handle]');
    if (!btn) return;

    // Do not intercept if it's the remove button inside wishlist page
    if (btn.classList.contains('remove-wishlist-dropdown-btn') || btn.closest('#WishlistItemsGrid')) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = btn.getAttribute('data-wishlist-handle');
    let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

    if (wishlist.includes(handle)) {
      // Remove from wishlist
      wishlist = wishlist.filter(h => h !== handle);
    } else {
      // Add to wishlist
      wishlist.push(handle);
    }

    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    // Sync all wishlist buttons for this handle on the current page
    const matchingBtns = document.querySelectorAll(`[data-wishlist-handle="${handle}"]`);
    matchingBtns.forEach(b => {
      if (wishlist.includes(handle)) {
        b.classList.add('active');
        b.setAttribute('aria-label', 'Largo nga lista e dëshirave');
      } else {
        b.classList.remove('active');
        b.setAttribute('aria-label', 'Shto në listën e dëshirave');
      }
    });

    // Update count bubble
    updateWishlistCount();
  });
}

// 3. Update Wishlist Dropdown View
function updateWishlistDropdown() {
  const dropdown = document.querySelector('#header-wishlist-dropdown');
  if (!dropdown) return;

  const loadingEl = dropdown.querySelector('.dropdown-loading');
  const emptyEl = dropdown.querySelector('.dropdown-empty-state');
  const listEl = dropdown.querySelector('#header-wishlist-items');
  const footerEl = dropdown.querySelector('#header-wishlist-footer');

  const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

  if (wishlist.length === 0) {
    if (loadingEl) loadingEl.style.display = 'none';
    if (emptyEl) emptyEl.style.display = 'block';
    if (listEl) {
      listEl.style.display = 'none';
      listEl.innerHTML = '';
    }
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (loadingEl) loadingEl.style.display = 'block';
  if (emptyEl) emptyEl.style.display = 'none';
  if (listEl) listEl.style.display = 'none';
  if (footerEl) footerEl.style.display = 'none';

  // Fetch product details for each wishlist item in parallel
  const fetchPromises = wishlist.map(handle => 
    fetch(`/products/${handle}.js`)
      .then(res => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .catch(() => null)
  );

  Promise.all(fetchPromises)
    .then(products => {
      const validProducts = products.filter(p => p !== null);

      if (loadingEl) loadingEl.style.display = 'none';

      if (validProducts.length === 0) {
        if (emptyEl) emptyEl.style.display = 'block';
        return;
      }

      if (listEl) {
        listEl.style.display = 'flex';
        listEl.innerHTML = validProducts.map(product => {
          // Format money using custom implementation or window formatting
          let formattedPrice = '€' + (product.price / 100).toFixed(2);
          if (typeof formatMoney === 'function') {
            formattedPrice = formatMoney(product.price);
          } else if (window.money_format) {
            formattedPrice = window.money_format.replace('{{amount}}', (product.price / 100).toFixed(2)).replace('{{ amount }}', (product.price / 100).toFixed(2));
          }
          
          const imageUrl = product.featured_image ? product.featured_image : '//cdn.shopify.com/s/images/admin/no-image-large.gif';
          return `
            <div class="dropdown-item" data-handle="${product.handle}" style="display: flex; gap: 0.8rem; align-items: center; border-bottom: 1px solid rgba(255, 255, 255, 0.05); padding-bottom: 0.8rem;">
              <a href="${product.url}" style="width: 50px; height: 50px; flex-shrink: 0; border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 6px; overflow: hidden; background: #252525; display: flex; align-items: center; justify-content: center; text-decoration: none;">
                <img src="${imageUrl}" alt="${product.title}" style="max-width: 100%; max-height: 100%; object-fit: contain;">
              </a>
              <div style="flex-grow: 1; display: flex; flex-direction: column; gap: 0.2rem; min-width: 0; text-align: left;">
                <a href="${product.url}" style="font-size: 0.8rem; font-weight: 600; color: #FFFFFF; text-decoration: none; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block; transition: var(--transition);">${product.title}</a>
                <span style="font-size: 0.8rem; color: var(--color-price); font-weight: 700;">${formattedPrice}</span>
              </div>
              <button class="remove-wishlist-dropdown-btn" data-handle="${product.handle}" style="background: none; border: none; color: #ef4444; cursor: pointer; padding: 0.2rem; font-size: 1.2rem; font-weight: 700; display: flex; align-items: center; justify-content: center; margin-left: auto;" title="Largo">×</button>
            </div>
          `;
        }).join('');
      }

      if (footerEl) footerEl.style.display = 'block';
    })
    .catch(err => {
      console.error('Error loading wishlist dropdown:', err);
      if (loadingEl) loadingEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = 'block';
    });
}
